var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../../interface/IVueDialog";
import { Loading } from 'element-ui';
import ShoppingManageService from '../../../../api/ShoppingManageService';
import AddClient from './addClientCol2/AddClient';
function formateHourMinute(num) {
    return (num + '').length == 2 ? (num + '') + ':00' : ('0' + num) + ':00';
}
function formateNumber(str) {
    return str ? str.slice(0, 2) - 0 : str;
}
var EditDialog = (function (_super) {
    __extends(EditDialog, _super);
    function EditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.purchase_time_id = '';
        _this.formData = {
            time_name: '',
            s_time: '00:00',
            e_time: '23:59',
            business: []
        };
        _this.selectedTime = '';
        _this.openSwitch = true;
        _this.checkboxGroup = ['1', '2', '3', '4', '5', '6'];
        _this.dataOptions = [
            {
                label: '周一',
                id: '1'
            },
            {
                label: '周二',
                id: '2'
            },
            {
                label: '周三',
                id: '3'
            },
            {
                label: '周四',
                id: '4'
            },
            {
                label: '周五',
                id: '5'
            },
            {
                label: '周六',
                id: '6'
            },
            {
                label: '周天',
                id: '0'
            }
        ];
        return _this;
    }
    EditDialog.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    EditDialog.prototype.created = function () {
        this.service = ShoppingManageService.getInstance();
    };
    EditDialog.prototype.mounted = function () {
        if (this.purchase_time_id) {
            this.getDetail();
        }
    };
    EditDialog.prototype.sTimeBlur = function () {
        this.formData.s_time = this.formData.s_time.replace('：', ':');
        if (!this.formData.s_time.includes(':')) {
            this.formData.s_time = '00:00';
            return false;
        }
        if (!this.isTimeInRange(this.formData.s_time)) {
            this.formData.s_time = '00:00';
        }
    };
    EditDialog.prototype.eTimeBlur = function () {
        this.formData.e_time = this.formData.e_time.replace('：', ':');
        if (!this.formData.e_time.includes(':')) {
            this.formData.e_time = '23:59';
            return false;
        }
        if (!this.isTimeInRange(this.formData.e_time)) {
            this.formData.e_time = '23:59';
        }
        this.isEtimeValid();
    };
    EditDialog.prototype.isEtimeValid = function () {
        var _a = this.formData.s_time.split(':'), sHours = _a[0], sMinutes = _a[1];
        var _b = this.formData.e_time.split(':'), eHours = _b[0], eMinutes = _b[1];
        var sTime = parseInt(sHours) * 60 + parseInt(sMinutes);
        var eTime = parseInt(eHours) * 60 + parseInt(eMinutes);
        if (eTime <= sTime) {
            this.$message.warning('结束时间必须大于开始时间');
            return false;
        }
        return true;
    };
    EditDialog.prototype.isTimeValid = function (value) {
        var regex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9])$/;
        return regex.test(value);
    };
    EditDialog.prototype.isTimeInRange = function (value) {
        if (!this.isTimeValid(value)) {
            return false;
        }
        var _a = value.split(':'), hours = _a[0], minutes = _a[1];
        var time = parseInt(hours) * 60 + parseInt(minutes);
        var startTime = 0;
        var endTime = 23 * 60 + 59;
        return time >= startTime && time <= endTime;
    };
    EditDialog.prototype.toAddClient = function () {
        var _this = this;
        var dialog = this.$dialog(AddClient, {
            data: {
                addedDatas: this.formData.business
            }
        }, {
            title: "添加客户",
            width: 950,
            height: 500
        });
        dialog.instance.$on("save:ok", function (res) {
            _this.formData.business = res;
            _this.selections = [];
        });
    };
    EditDialog.prototype.deleteClient = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择客户");
            return;
        }
        this.$confirm("请确认是否删除该客户", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.formData.business.indexOf(item);
                _this.formData.business.splice(index, 1);
            });
        }, function (err) { });
    };
    EditDialog.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDetailPurchasetime({ purchase_time_id: this.purchase_time_id }).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.checkboxGroup = data.day_week.length !== 0 ? data.day_week.split(',') : ['1', '2', '3', '4', '5', '6'];
            data.business = data.bussiness;
            _this.formData = data;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    EditDialog.prototype.close = function () {
        this.$closeDialog();
    };
    EditDialog.prototype.save = function () {
        if (!this.formData.s_time || !this.formData.e_time) {
            this.$message.warning("开始时间与结束时间不能为空");
            return false;
        }
        if (!this.checkboxGroup.length) {
            this.$message.warning("订货时段周期不能为空");
            return false;
        }
        if (!this.isEtimeValid()) {
            return false;
        }
        if (this.purchase_time_id) {
            this.editSave();
        }
        else {
            this.addSave();
        }
    };
    EditDialog.prototype.addSave = function () {
        var _this = this;
        if (!this.checkSave()) {
            return;
        }
        var formData = this.formData;
        var params = {
            time_name: formData.time_name,
            s_time: formData.s_time,
            e_time: formData.e_time,
            day_week: this.checkboxGroup.join(','),
            business: JSON.stringify(formData.business.map(function (v) { return v.business_id; }))
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.addSavePurchasetime(params).then(function (res) {
            loadingInstance.close();
            _this.$closeDialog();
            _this.$emit('editDialog:ok', {});
            window._czc.push(["_trackEvent", '添加订货时段设置', '保存', '保存']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    EditDialog.prototype.editSave = function () {
        var _this = this;
        if (!this.checkSave()) {
            return;
        }
        var formData = this.formData;
        var params = {
            time_name: formData.time_name,
            s_time: formData.s_time,
            e_time: formData.e_time,
            day_week: this.checkboxGroup.join(','),
            business: JSON.stringify(formData.business.map(function (v) { return v.business_id; }))
        };
        params = Object.assign({}, params, { purchase_time_id: this.purchase_time_id });
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.editSavePurchasetime(params).then(function (res) {
            loadingInstance.close();
            _this.$closeDialog();
            _this.$emit('editDialog:ok', {});
            window._czc.push(["_trackEvent", '修改订货时段设置', '保存', '保存']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    EditDialog.prototype.checkSave = function () {
        if (!this.formData.time_name) {
            this.$message.warning("名称不可为空");
            return false;
        }
        return true;
    };
    EditDialog = __decorate([
        Component
    ], EditDialog);
    return EditDialog;
}(VueDialog));
export default EditDialog;
